// @flow
export const stringCleanWithDot = (str: string): string => {
  return str.toLowerCase().replace(/[^a-zA-Z0-9.]+/g, '-')
}

export const stringClean = (str: string): string => {
  return str.toLowerCase().replace(/[^a-zA-Z0-9]+/g, '-')
}
